export const ensureUrlProtocol = (url?: null | string): string => {
  const trimmed = url?.trim() ?? '';
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};
